// Wording follows the legacy system pages of track (admin/account/account.vm, accountEditSysAdmin.vm).
export const LABELS_ADMIN_ACCOUNTS = {
	navigate: "Система (нова)",
	title: "Системні акаунти",
	searchPlaceholder: "Пошук за ід. акаунта, описом, організацією або #id",
	code: "Ід. акаунта",
	description: "Опис акаунта",
	labelName: "Назва організації",
	state: "Активно",
	yes: "Так",
	no: "Ні",
	maximumDevicesAvailable: "Трекерів доступно",
	activeDevices: "Активних",
	maximumDevices: "Максимальна кількість пристроїв (трекерів)",
	maximumDevicesShort: "Ліміт трекерів",
	unlimited: "\"0\" - без обмежень",
	deviceCount: "Кількість трекерів",
	inactiveDeviceCount: "Договір закінчився",
	createdAt: "Створено",
	lastLoginAt: "Ост. вхід",
	online: "В системі",
	stateYES: "Активний",
	stateNO: "Неактивний",
	stateTENANT: "Сисадмін аккаунт",
	stateEXTENDED: "Мульти акаунт",
	summaryTotal: "Усього акаунтів",
	summaryDevices: "Активних трекерів / всього",
	filterActive: "Активні",
	filterInactive: "Неактивні",
	filterMulti: "Мульти акаунти",
	filterOnline: "Зараз в системі",
	onlineTooltip: "Адмін: {{admins}}, користувачі: {{users}}",
	never: "Ніколи",
	today: "Сьогодні",
	yesterday: "Вчора",
	daysAgo: "{{count}} дн. тому",
	monthsAgo: "{{count}} міс. тому",
	yearsAgo: "{{count}} р. тому",
	connect: "Підключитись",
	connectInactive: "Акаунт неактивний, підключитись до нього неможливо",
	connectConfirmTitle: "Бажаєте підключитись до акаунта?",
	connectConfirmText: "Ви увійдете в {{code}} як адмін акаунта. Повернутися у свій акаунт чи перейти в інший можна кнопкою акаунта у шапці.",
	connectInactiveText: "Спершу активуйте акаунт на сторінці редагування.",
	connectUserConfirmTitle: "Бажаєте підключитись як цей користувач?",
	connectUserConfirmText: "Ви увійдете в {{code}} як {{login}} і побачите систему його очима. Повернутися у свій акаунт чи перейти в інший можна кнопкою акаунта у шапці.",
	edit: "Редагувати",
	back: "Системні акаунти",
	release: "Повернутися в {{account}}",
	switcherTitle: "Перемкнути акаунт",
	switcherTooltip: "Перемкнути акаунт",
	switcherConnectedTooltip: "Ви в {{code}}, підключились як {{user}}. Натисніть, щоб перемкнути акаунт",
	switcherYouAreIn: "Зараз ви у своєму акаунті {{code}}",
	switcherConnectedAs: "Зараз ви в {{code}}, підключились як {{user}}",
	switcherSearch: "Пошук акаунта за кодом чи описом",
	switcherOwn: "Мій акаунт",
	switcherCurrent: "Поточний",
	switcherMulti: "Мульти",
	switcherNothing: "Нічого не знайдено",
	switcherConfirm: "Перейти в {{code}} як адмін акаунта?",
	switcherConfirmUser: "Перейти в {{code}} як {{login}}?",
	switcherGo: "Перейти",
	switcherFavorites: "Обрані",
	switcherAll: "Усі акаунти",
	switcherFavorite: "Додати в обрані",
	switcherUnfavorite: "Прибрати з обраних",
	switcherFavoritesHint: "Позначте зірочкою акаунти, до яких заходите найчастіше: вони будуть угорі списку.",
	switcherAsUser: "Підключитись як користувач",
	switcherUsersTitle: "Підключитись до {{code}} як…",
	switcherUsersSearch: "Пошук користувача за логіном чи іменем",
	switcherAsAdmin: "Адмін акаунта",
	switcherNoUsers: "В акаунті немає користувачів",
	switcherBack: "До списку акаунтів",
	switcherFilter: {
		all: "Усі",
		active: "Активні",
		multi: "Мульти",
		inactive: "Неактивні",
	},
	dateCreating: "Дата створення",
	dateOfLastEntry: "Дата останнього входу",
	cardMain: "Акаунт",
	cardAdmin: "Адмін акаунта",
	cardModules: "Доступ до модулів",
	cardMultiAccounts: "Мульти акаунти",
	cardServices: "Сервери",
	active: "Активний",
	activeHint: "Неактивний акаунт не може увійти в систему",
	notes: "Загальні зауваження",
	contactName: "Адмін акаунта",
	contactEmail: "Ел. пошта адміна",
	contactPhone: "Телефон адміна",
	invalidEmail: "Некоректна ел. пошта",
	visibleFuelInfo: "Показувати інформацію по паливу",
	visibleSingleVoyage: "Доступ до модуля \"Разовий рейс\"",
	visibleStaffSchedule: "Доступ до модуля \"Штатний розпис\"",
	multiAccountIds: "Надати доступ разових рейсів мультиаккаунтам",
	shareDefaultGroup: "Надати пов'язаним мульти-акаунтам доступ до геолокації всіх ТЗ на карті",
	shareDefaultGroupHint: "Надати доступ стандартної групи «All» пов’язаним мультиакаунтам",
	shareToMultiAccountIds: "Оберіть мультиакаунти для доступу до всіх ТЗ",
	multiAccountNoShare: "Мульти акаунт не ділиться своєю групою «All»",
	addressGeocodingServer: "Адреса сервера геокодування координат",
	apiKeyGeocodingServer: "API ключ сервера геокодування координат",
	addressRoutingServer: "Адреса роутингового сервера",
	apiKeyRoutingServer: "API ключ роутингового сервера",
	addressTransitPredictionServer: "URL-адреса сервера прогнозування руху",
	apiKeyTransitPredictionServer: "API ключ сервера прогнозування руху",
	legacyNote: "Корпоративні стилі змінюються на старій сторінці акаунта. Тарифів у системі немає, тому їх не показано",
	multiAccount: "Ознака мульти акаунта",
	multiAccountHint: "Мульти акаунт бачить об'єкти інших акаунтів; акаунт з власними пристроями ним бути не може",
	tenantAdmin: "Сисадмін аккаунт",
	tenantAdminHint: "для аккаунту орендаря: створює для нього власний тенант",
	tenantAdminSet: "Акаунт уже адмініструє тенант; на цій сторінці це не скасовується",
	adminPassword: "Пароль адміна",
	adminPasswordHint: "Залиште порожнім, щоб не змінювати.",
	passwordChangedAt: "Змінено {{date}}.",
	geocoderMode: "Геокодування координат (зворотнє)",
	geocoderModeGEOZONE: "У геозонах",
	geocoderModeFULL: "Повне (зовнішній сервер)",
	geocoderProvider: "Геокодування адреси (пряме)",
	smsProperties: "SMS",
	create: "Новий акаунт",
	createTitle: "Новий акаунт",
	createText: "Акаунт отримає групу «All» і з'явиться в тенанті. Решту налаштувань задасте на сторінці редагування.",
	createCode: "Ід. акаунта",
	createCodeHint: "Латиниця, цифри, @ . _ -",
	created: "Акаунт зареєстровано успішно",
	openLegacy: "Стара сторінка",
	unsaved: "Є незбережені зміни",
	saved: "Усі зміни збережено",
	cancel: "Скасувати",
	save: "Зберегти",
	noAccess: "Сторінка доступна адміністратору тенанта",
	notFound: "Акаунт не знайдено",
}
